export default "__VITE_ASSET__fea2a5fe__"